// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-ceasing-operations-js": () => import("./../../../src/pages/ceasing-operations.js" /* webpackChunkName: "component---src-pages-ceasing-operations-js" */),
  "component---src-pages-consumers-js": () => import("./../../../src/pages/consumers.js" /* webpackChunkName: "component---src-pages-consumers-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-referrals-js": () => import("./../../../src/pages/referrals.js" /* webpackChunkName: "component---src-pages-referrals-js" */)
}

